export default __webpack_public_path__ + "static/placeholder-3-592368668a651db5e992c45730cca66b.jpg";